import { ACTIONS } from './action.js';
import uuid from 'react-uuid';

export default function reducer(state, action) {

  switch (action.type) {

    case ACTIONS.UPDATE:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state;
  }
}